
<!-- Please don’t change these IDs because those are for automated testing:- playStoreLink, appStoreLink, signUpFnameInput, signUpLnameInput,signUpUnameInput, signUpEmailInput, signUpPwdInput, signUpAdsOneInput, signUpAdsTwoInput, signUpPNInput, signUpCityInput, signUpStateInput, signUpCountryInput, signUpZcodeInput, signUpImgUploadInput, signUpNextBtn, loginLink  -->
<div class="mid_container no-padding signup-page">
  <div class="sm_container">
    <div class="login__page">
      <!-- Step 1 start here-->
      <div class="row" [hidden]="formSteps.currentStep != keys.STEP_1">
        <div class="col-lg-5 col-md-5 col-sm-5 ">
          <div class="signup__left signup__bg__left">
            <div class="signup__step__text">
              <ul>
                <li>
                  <div class="step__text">
                    <strong>{{translations.GLOBAL.KEYS.MERCHANT_DETAILS | translate }} </strong>
                    <p>{{ translations.GLOBAL.KEYS.SIGN_UP_intro_TEXT_ONE | translate }} </p>
                    <p class="text-margin-top-15">{{ translations.GLOBAL.KEYS.SIGN_UP_intro_TEXT_TWO | translate }}</p>
                    <p class="text-margin-top-15">{{ translations.GLOBAL.KEYS.SIGN_UP_intro_TEXT_THREE | translate }}</p>
                  </div>
                  <!-- <div class="step__number">1</div> -->
                  <div class="app__store__btns">
                    <div class="appsstore__btn playstore">
                      <a id="playStoreLink" href="https://play.google.com/store/search?q=wellbux&c=apps" target="_blank"> <img src="/assets/images/google-play-store.png" alt="" /> </a>
                    </div>
                    <div class="appsstore__btn appstore">
                      <a id="appStoreLink"  href="https://apps.apple.com/in/app/wellbux/id1580335328" tabindex="0" target="_blank"> <img src="/assets/images/app-store.png" alt="" /> </a>
                    </div>
                  </div>
                </li>

              </ul>
            </div>

          </div>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-7">
          <div class="login__right">
            <h2>{{translations.GLOBAL.KEYS.SIGN_UP | translate }} </h2>
            <div class="signup__step__img">
              <div><img src="/assets/images/svg_icons/merchant-detail.svg" alt="icon" /></div>
              <strong>{{translations.GLOBAL.KEYS.FILL_UP_YOUR_MERCHANT_DETAIL | translate }} </strong>
            </div>
            <form [formGroup]="signUpForm" (ngSubmit)="onSubmit()">
              <div class="form">
                <div class="row">
                  <div class="col-lg-6 col-md-12 col-sm-6">
                    <div class="login__input">
                      <input type="text" id="signUpFnameInput" [placeholder]="getTranslation(translations.GLOBAL.KEYS.FIRST_NAME)" formControlName="fname" />
                      @if (fname.invalid && (submitted)) {
                        <div
                          class="custom_error">
                          @if (fname.errors) {
                            <div>
                              <!-- {{getCustomErrorMessage(fname, getTranslation(translations.GLOBAL.KEYS.FIRST_NAME), { noAllWhiteSpaceValidation:true, isAlphabaticPattern:true, minLength:2, maxLength:25 })}}-->
                              {{getCustomErrorMessage(fname, getTranslation(translations.GLOBAL.KEYS.FIRST_NAME) )}}
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-12 col-sm-6">
                    <div class="login__input">
                      <input type="text" id="signUpLnameInput" [placeholder]="getTranslation(translations.GLOBAL.KEYS.LAST_NAME)" formControlName="lname" />
                      @if (lname.invalid && (submitted)) {
                        <div
                          class="custom_error">
                          @if (lname.errors) {
                            <div>
                              <!-- {{getCustomErrorMessage(lname, getTranslation(translations.GLOBAL.KEYS.LAST_NAME), { noAllWhiteSpaceValidation:true, isAlphabaticPattern:true, minLength:2, maxLength:25 })}} -->
                              {{getCustomErrorMessage(lname, getTranslation(translations.GLOBAL.KEYS.LAST_NAME) )}}
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <div class="login__input">
                      <input type="text" id="signUpUnameInput" [placeholder]="getTranslation(translations.GLOBAL.KEYS.USERNAME)" formControlName="username"/>
                      @if (username.invalid && (submitted)) {
                        <div
                          class="custom_error">
                          @if (username.errors) {
                            <div>
                              <!-- {{getCustomErrorMessage(username, getTranslation(translations.GLOBAL.KEYS.USERNAME), { cannotStartWithWhiteSpace:true, minLength:5,  maxLength:25 })}} -->
                              {{getCustomErrorMessage(username, getTranslation(translations.GLOBAL.KEYS.USERNAME), { noAllWhiteSpaceValidation:true })}}
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <div class="login__input">
                      <input type="text" id="signUpEmailInput"
                        [placeholder]="getTranslation(translations.GLOBAL.KEYS.EMAIL)"
                        formControlName="email" />
                      @if (email.invalid && submitted) {
                        <div class="custom_error">
                          <!-- Show specific email exists error if present -->
                          @if (email.errors?.emailNotUnique || email.errors?.isUnique) {
                            <div>
                              {{ getTranslation(translations.GLOBAL.KEYS.EMAIL) }} is already in use
                            </div>
                          }
                          <!-- Show other validation errors if no duplicate email error -->
                          @if (!(email.errors?.emailNotUnique || email.errors?.isUnique) && email.errors) {
                            <div>
                              {{ getCustomErrorMessage(email, getTranslation(translations.GLOBAL.KEYS.EMAIL),
                              { noAllWhiteSpaceValidation:true, isEmailPattern:true }) }}
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>



                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <div class="login__input password__box">
                      <input id="signUpPwdInput" type="{{type}}" readonly onfocus="this.removeAttribute('readonly');"
                        [placeholder]="getTranslation(translations.GLOBAL.KEYS.PASSWORD)" formControlName="password" />
                      <div class="password-hide-icon" (click)="toggleToPasswordShow()">
                        <i [ngClass]="{'fa-eye-slash' : type == 'password'}" class="fa fa-eye"
                        aria-hidden="true"></i>
                      </div>

                      <!-- <div *ngIf="password.invalid && (submitted)"
                      class="custom_error">
                      {{getCustomErrorMessage(password, getTranslation(translations.GLOBAL.KEYS.PASSWORD), {noAllWhiteSpaceValidation:true,isAlphanumericPattern:true})}}
                    </div> -->
                    @if (password.invalid && submitted) {
                      <div class="custom_error">
                        @if (password.errors?.required) {
                          <div>Password is required</div>
                        }
                        @if (password.errors?.minLength) {
                          <div>{{ password.errors.minLength }}</div>
                        }
                        @if (password.errors?.uppercase) {
                          <div>{{ password.errors.uppercase }}</div>
                        }
                        @if (password.errors?.letterNumber) {
                          <div>{{ password.errors.letterNumber }}</div>
                        }
                        @if (password.errors?.specialChar) {
                          <div>{{ password.errors.specialChar }}</div>
                        }
                        @if (password.errors?.noSpaces) {
                          <div>{{ password.errors.noSpaces }}</div>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12" formGroupName="profileData">
                  <div class="login__input">
                    <input type="text" id="signUpPNInput" [placeholder]="getTranslation(translations.GLOBAL.KEYS.BUSINESS_PHONE_NUMBER)"
                      formControlName="mobileNumber" (input)="formatPhoneNumber($event)" />
                    @if (userProfileDataForm.mobileNumber.invalid && (submitted)) {
                      <div  class="custom_error">
                        @if (userProfileDataForm.mobileNumber.errors?.required) {
                          <div>
                            {{getTranslation(translations.GLOBAL.KEYS.BUSINESS_PHONE_NUMBER)}} is required
                          </div>
                        }
                        @if (userProfileDataForm.mobileNumber.errors?.pattern) {
                          <div>
                            Please enter a valid US phone number (XXX-XXX-XXXX)
                          </div>
                        }
                      </div>
                    }

                  </div>
                </div>
              </div>




              <!-- <div  *ngIf="!storeAttributes.defaultManuallAddress" class="row" formGroupName="address"> -->
              <div class="row" formGroupName="address">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <!-- <div class="manually_address_link"> <a href="javascript:void(0)" (click)="enableManuallAddress()">Enter manually address</a></div> -->
                  <div class="login__input">
                    <input id="signUpAdsOneInput" type="googleInputLocation" [placeholder]="getTranslation(translations.GLOBAL.KEYS.ADDRESS_1)" autocorrect="off" #search
                      (locFormGroupDataChanged)='patchDataForLocFormGroup($event)'
                      formControlName="formattedAddress" />
                    @if (userAddressForm.formattedAddress.invalid
                      && (submitted)) {
                      <div
                        class="custom_error">
                        @if (userAddressForm.formattedAddress.errors.required) {
                          <div>
                            {{getCustomErrorMessage(userAddressForm.formattedAddress, getTranslation(translations.GLOBAL.KEYS.ADDRESS_1))}}
                          </div>
                        }
                        @if (userAddressForm.formattedAddress.errors.isValidAddressFromList && !userAddressForm.formattedAddress.errors.required) {
                          <div
                            >
                            {{translations.GLOBAL.VALIDATION_MESSAGES.PLEASE_SELECT_VALID_ADDRESS | translate }}
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div class="row" formGroupName="address">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="login__input">
                    <input type="text" id="signUpAdsTwoInput" [placeholder]="getTranslation(translations.GLOBAL.KEYS.ADDRESS_2)" formControlName="customAddress" />
                    <div class="custom_error">
                      <!-- {{getCustomErrorMessage(userAddressForm.customAddress, getTranslation(translations.GLOBAL.KEYS.CUSTOM_ADDRESS), {cannotStartWithWhiteSpace:true})}} -->
                      {{getCustomErrorMessage(userAddressForm.customAddress, getTranslation(translations.GLOBAL.KEYS.CUSTOM_ADDRESS) )}}
                    </div>
                  </div>

                </div>
              </div>
              <div class="row">

                <div class="col-lg-6 col-md-12 col-sm-6" formGroupName="address">
                  <div class="login__input">
                    <input type="text" id="signUpCityInput" [placeholder]="getTranslation(translations.GLOBAL.KEYS.CITY)" formControlName="city" />
                    @if (userAddressForm.city.invalid && (submitted)) {
                      <div class="custom_error">
                        @if (userAddressForm.city.errors) {
                          <div>
                            <!-- {{getCustomErrorMessage(userAddressForm.city, getTranslation(translations.GLOBAL.KEYS.CITY), { cannotStartWithWhiteSpace: true })}} -->
                            {{getCustomErrorMessage(userAddressForm.city, getTranslation(translations.GLOBAL.KEYS.CITY) )}}
                          </div>
                        }
                      </div>
                    }
                  </div>

                </div>
                <div class="col-lg-6 col-md-12 col-sm-6" formGroupName="address">
                  <div class="login__input">
                    <input type="text" id="signUpStateInput" [placeholder]="getTranslation(translations.GLOBAL.KEYS.STATE)" formControlName="state" />
                    @if (userAddressForm.state.invalid && (submitted)) {
                      <div
                        class="custom_error">
                        @if (userAddressForm.state.errors) {
                          <div>
                            <!-- {{getCustomErrorMessage(userAddressForm.state, getTranslation(translations.GLOBAL.KEYS.STATE), { cannotStartWithWhiteSpace: true })}} -->
                            {{getCustomErrorMessage(userAddressForm.state, getTranslation(translations.GLOBAL.KEYS.STATE) )}}
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-6" formGroupName="address">
                  <div class="login__input">
                    <input type="text" id="signUpCountryInput" [placeholder]="getTranslation(translations.GLOBAL.KEYS.COUNTRY)" formControlName="country" />
                    @if (userAddressForm.country.invalid && (submitted)) {
                      <div
                        class="custom_error">
                        @if (userAddressForm.country.errors) {
                          <div>
                            <!-- {{getCustomErrorMessage(userAddressForm.country, getTranslation(translations.GLOBAL.KEYS.COUNTRY), { cannotStartWithWhiteSpace: true })}} -->
                            {{getCustomErrorMessage(userAddressForm.country, getTranslation(translations.GLOBAL.KEYS.COUNTRY) )}}
                          </div>
                        }
                      </div>
                    }
                  </div>

                </div>

                <div class="col-lg-6 col-md-12 col-sm-6" formGroupName="address">
                  <div class="login__input">
                    <input type="text" id="signUpZcodeInput" [placeholder]="getTranslation(translations.GLOBAL.KEYS.ZIP_CODE)" formControlName="postalCode" />
                    @if (userAddressForm.postalCode.invalid && (submitted)) {
                      <div
                        class="custom_error">
                        @if (userAddressForm.postalCode.errors) {
                          <div>
                            <!-- {{getCustomErrorMessage(userAddressForm.postalCode, getTranslation(translations.GLOBAL.KEYS.ZIP_CODE), { noAllWhiteSpaceValidation:true, isAlphanumericPattern:true, minLength:4, maxLength:12 })}} -->
                            {{getCustomErrorMessage(userAddressForm.postalCode, getTranslation(translations.GLOBAL.KEYS.ZIP_CODE), { isAlphanumericPattern:true })}}
                          </div>
                        }
                      </div>
                    }
                  </div>

                </div>
              </div>


              <!-- <div class="row" *ngIf="!storeAttributes.defaultManuallAddress"> -->


              <!-- <div *ngIf="storeAttributes.defaultManuallAddress">
              <div class="manually_address_link">   <a href="javascript:void(0)" (click)="enableGoogleAddress()">Enter Google address</a></div>
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12" formGroupName="manuallAddress">
                  <div class="login__input">
                    <input type="text" placeholder="Address 1" formControlName="storeAddress1" autocorrect="off" autocapitalize="off" spellcheck="off" #search (click)="searchGoogleAutocompleteAddress($event)"/>
                    <div *ngIf="manuallAddressForm.storeAddress1.invalid && submitted" class="custom_error">
                      <div *ngIf="manuallAddressForm.storeAddress1.errors.required">Address1 is required.</div>
                    </div>
                  </div>
                </div>

              </div>


              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12" formGroupName="manuallAddress">
                  <div class="login__input">
                    <input type="text" placeholder="Address 2" formControlName="storeAddress2" />
                    <div *ngIf="manuallAddressForm.storeAddress2.invalid && submitted" class="custom_error">
                      <div *ngIf="manuallAddressForm.storeAddress2.errors.required">Address2 is required.</div>
                    </div>
                  </div>
                </div>
              </div>



              <div class="row">
                <div class="col-lg-6 col-md-12 col-sm-6" formGroupName="manuallAddress">
                  <div class="login__input">
                    <input type="text" placeholder="Country" formControlName="country" />
                    <div *ngIf="manuallAddressForm.country.invalid && submitted" class="custom_error">
                      <div *ngIf="manuallAddressForm.country.errors.required">Address2 is required.</div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-6" formGroupName="manuallAddress">
                  <div class="login__input">
                    <input type="text" placeholder="City" formControlName="city" />
                    <div *ngIf="manuallAddressForm.city.invalid && submitted" class="custom_error">
                      <div *ngIf="manuallAddressForm.city.errors.required">Address2 is required.</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6 col-md-12 col-sm-6" formGroupName="manuallAddress">
                  <div class="login__input">
                    <input type="text" placeholder="State" formControlName="state" />
                    <div *ngIf="manuallAddressForm.state.invalid && submitted" class="custom_error">
                      <div *ngIf="manuallAddressForm.state.errors.required">Address2 is required.</div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-6" formGroupName="manuallAddress">
                  <div class="login__input">
                    <input type="text" placeholder="Zip code" formControlName="postalCode" />
                    <div *ngIf="manuallAddressForm.postalCode.invalid && submitted" class="custom_error">
                      <div *ngIf="manuallAddressForm.postalCode.errors.required">Address2 is required.</div>
                    </div>
                  </div>
                </div>
              </div>


            </div> -->



            <div class="signup__upload__img clearfix">
              <div class="signup_upload_img_input signup_upload__img__box">
                <div class="signup_upload__input_opcty" [ngClass]="{edituploadimg: signUpForm.value.profileData.image}">
                  <input id="signUpImgUploadInput" type="file" ng2FileSelect [uploader]="uploader"
                    (change)="onImageSelect($event)" accept="image/*">
                  </div>
                  @if (!signUpForm.value.profileData.image) {
                    <div class="signup_upload_img_text">
                      <img width="100%" src="/assets/images/svg_icons/upload-photo.svg" alt="" />
                    </div>
                  }
                  @if (signUpForm.value.profileData.image) {
                    <div class="signup_upload_img_text">
                      <img width="100%"
                        [src]="(imageCdn + 'w_300,h_300/' + ((imageBaseUrl + '/' + signUpForm.value.profileData.image) | encodeUri))"
                        alt="loading..." />
                    </div>
                  }
                </div>

                @if (userProfileDataForm.image.invalid && (submitted)) {
                  <div  class="custom_error">
                    @if (userProfileDataForm.image.errors) {
                      <div>{{translations.GLOBAL.VALIDATION_MESSAGES.REQUIRED | translate :
                        {'name': translations.GLOBAL.KEYS.IMAGE | translate}
                        }}
                      </div>
                    }
                  </div>
                }
              </div>
              <div class="sign__up__btn clearfix">
                <div class="next__btn"><a href="javascript:void(0)" id="signUpNextBtn" (click)="onSubmit()"
                class="signup__step_btn">{{translations.GLOBAL.KEYS.NEXT | translate }} </a></div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Step 1 end here-->

    <!-- Step 2 start here-->
    <div class="row" [hidden]="formSteps.currentStep != keys.STEP_2">
      <div class="col-lg-5 col-md-5 col-sm-5 ">
        <div class="signup__left signup__bg__left">
          <div class="signup__step__text">
            <ul>
              <li>
                <div class="step__text">
                  <strong>{{translations.GLOBAL.KEYS.MERCHANT_DETAILS | translate }} </strong>
                  <p>{{ translations.GLOBAL.KEYS.SIGN_UP_intro_TEXT_ONE | translate }} </p>
                  <p class="text-margin-top-15">{{ translations.GLOBAL.KEYS.SIGN_UP_intro_TEXT_TWO | translate }}</p>
                  <p class="text-margin-top-15">{{ translations.GLOBAL.KEYS.SIGN_UP_intro_TEXT_THREE | translate }}</p>
                </div>
                <!-- <div class="step__number">1</div> -->
                <div class="app__store__btns">
                  <div class="appsstore__btn playstore">
                    <a id="playStoreLink" href="https://play.google.com/store/search?q=wellbux&c=apps" target="_blank"> <img src="/assets/images/google-play-store.png" alt="" /> </a>
                  </div>
                  <div class="appsstore__btn appstore">
                    <a id="appStoreLink"  href="https://apps.apple.com/in/app/wellbux/id1580335328" tabindex="0" target="_blank"> <img src="/assets/images/app-store.png" alt="" /> </a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-7 col-md-7 col-sm-7">
        <div class="login__right">
          <h2>{{translations.GLOBAL.KEYS.SIGN_UP | translate }}  </h2>
          <div class="signup__step__img">
            <div><img src="/assets/images/svg_icons/store-detail.svg" alt="icon" /></div>
            <strong>{{translations.STORE.FILL_UP_YOUR_STORE_DETAIL | translate }} </strong>
          </div>
          <div class="store-form-admin">
            <app-store-add-edit-template
              [isSignUpForm]="true"
              (storeDetailsSubmit)="onCreateStore($event)"
              (storeFormSkip)="triggerNextStep($event)">
            </app-store-add-edit-template>
          </div>

        </div>
      </div>
    </div>
    <!-- Step 2 end here-->

    <!-- Step 3 start here-->
    <div class="row" [hidden]="formSteps.currentStep != keys.STEP_3">
      <div class="registration__successfully">
        <div class="step__text">
          <div class="successfully__icon"><i class="far fa-check-circle"></i></div>
          <h2>{{translations.GLOBAL.KEYS.WELCOME | translate }} !!</h2>
          <P>{{systemConstants.SIGN_UP_REGISTER_MSG}}</P>
          <div class="btn-signin">
            <a href="javascript:void(0)" id="loginLink" routerLink="/login" class="signup__step_btn">{{translations.GLOBAL.KEYS.LOGIN | translate }} </a>
          </div>
        </div>
      </div>
    </div>
    <!-- Step 3 end here-->
  </div>
</div>
</div>
<!-------------Mid End----------------->
